import { Fandango_debugLog as debugLog } from '@grins/fd-modules/splits/onering-global';

import forgotPasswordForm from '@grins/fd-modules/bonz/modules/forgotPassword';

function run() {
  debugLog.info('shared/bonz/forgotPassword.app', 'ready');
  forgotPasswordForm.init();
}
run();
